import { createPortal } from "react-dom";
import { fmtNum, fmtInt, fmtBags } from "@/lib/format";

const cell = { border: "1px solid #cbd5e1", padding: "6px 10px", fontSize: "12px" };
const th = { ...cell, background: "#f1f5f9", textAlign: "left", fontWeight: 700, textTransform: "uppercase", fontSize: "10px", letterSpacing: "0.05em" };

function MatTable({ title, rows }) {
  if (!rows.length) return null;
  return (
    <div style={{ marginTop: "14px" }}>
      <div style={{ fontWeight: 800, fontSize: "13px", marginBottom: "4px", color: "#0f172a" }}>{title}</div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={th}>Size</th>
            <th style={{ ...th, textAlign: "right" }}>Pcs</th>
            <th style={{ ...th, textAlign: "right" }}>Kg</th>
            <th style={{ ...th, textAlign: "right" }}>Bags</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.size}>
              <td style={{ ...cell, fontWeight: 700 }}>{r.size}</td>
              <td style={{ ...cell, textAlign: "right" }}>{fmtInt(r.pcs)}</td>
              <td style={{ ...cell, textAlign: "right" }}>{fmtNum(r.kg, 1)}</td>
              <td style={{ ...cell, textAlign: "right" }}>{fmtBags(r.kg / 50)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function PrintSheet({ order, data }) {
  const date = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  return createPortal(
    <div id="print-area">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", borderBottom: "3px solid #0f172a", paddingBottom: "8px" }}>
        <div>
          <div style={{ fontSize: "28px", fontWeight: 900, letterSpacing: "-0.02em" }}>
            TR <span style={{ color: "#EA580C" }}>BOLT</span>
          </div>
          <div style={{ fontSize: "11px", color: "#475569", textTransform: "uppercase", letterSpacing: "0.08em" }}>Material Shifting Sheet</div>
        </div>
        <div style={{ textAlign: "right", fontSize: "12px" }}>
          <div style={{ fontWeight: 700 }}>{order.name}</div>
          <div style={{ color: "#475569" }}>{date}</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: "24px", marginTop: "12px", fontSize: "13px", fontWeight: 700 }}>
        <div>TOTAL WEIGHT: <span style={{ color: "#EA580C" }}>{fmtNum(data.totalKg, 1)} KG</span></div>
        <div>TOTAL BAGS: <span style={{ color: "#EA580C" }}>{fmtBags(data.totalBags)}</span></div>
      </div>

      <MatTable title="BOLTS" rows={data.bolts} />
      <MatTable title="NUTS" rows={data.nuts} />
      <MatTable title="WASHERS" rows={data.washers} />

      <div style={{ marginTop: "16px" }}>
        <div style={{ fontWeight: 800, fontSize: "13px", marginBottom: "4px" }}>ORDER LINES</div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={th}>Bolt Size</th>
              <th style={th}>Assembly</th>
              <th style={{ ...th, textAlign: "right" }}>Bags</th>
              <th style={{ ...th, textAlign: "right" }}>Sets</th>
            </tr>
          </thead>
          <tbody>
            {order.lines.map((l) => {
              const bags = l.bolt.bags + l.nut.bags + (l.washer?.bags || 0);
              return (
                <tr key={l.id}>
                  <td style={{ ...cell, fontWeight: 700 }}>{l.bolt.size}</td>
                  <td style={cell}>{l.assemblyText}</td>
                  <td style={{ ...cell, textAlign: "right", fontWeight: 800, fontSize: "14px", color: "#EA580C" }}>{fmtBags(bags)}</td>
                  <td style={{ ...cell, textAlign: "right", fontSize: "10px", color: "#64748b" }}>{fmtInt(l.sets)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: "20px", fontSize: "10px", color: "#94a3b8" }}>
        Rates are approximate (count per 50 kg). Generated by TR BOLTcalc.
      </div>
    </div>,
    document.body
  );
}
